export const tr = {
    platform: 'Göster',
    strategy: 'Strateji'
};
